import { Col, Row, Skeleton } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { GetCourseContent } from "./ajax";
import courseTitleIcon from "../img/ourCourse/titleImg.png";
import mainCourseImg1 from "../img/ourCourse/mainCoursePh.png";
import trainCourseImg1 from "../img/ourCourse/trainCoursePh.png";
import arrow from "../img/ourCourse/btn_arrow.png";
export function ThreeCourseInfo(props) {
  const [loading, setLoading] = useState(false);
  const [courseList, setCourseList] = useState({
    mainCourse: [],
    trainCourse: [],
  });
const windowRef = useRef(null);
const windowRef2 = useRef(null);
const [windowWidth, setWindowWidth] = useState(0);
const [windowWidth2, setWindowWidth2] = useState(0);
const [pageIndex, setPageIndex] = useState(0);
const [pageIndex2, setPageIndex2] = useState(0);
const maxPage = 1;
  const maxPage2 = 1;
  const nextPage = () => {
    if (pageIndex < maxPage) {
      setPageIndex(pageIndex + 1);
    }
  };
  const PrevPage = () => {
    if (pageIndex>0) {
      setPageIndex(pageIndex -1);
    }
  };

  const nextPage2 = () => {
    if (pageIndex2 < maxPage2) {
      setPageIndex2(pageIndex2 + 1);
    }
  };
  const PrevPage2 = () => {
    if (pageIndex2 > 0) {
      setPageIndex2(pageIndex2 - 1);
    }
  };
  

  
  
  useEffect(() => {
     const updateWidth = () => {
       if (windowRef.current) {
         setWindowWidth(windowRef.current.offsetWidth);
       }
     };

     updateWidth();
     window.addEventListener("resize", updateWidth);

     const updateWidth2 = () => {
       if (windowRef2.current) {
         setWindowWidth2(windowRef2.current.offsetWidth);
       }
     };

     updateWidth2();
     window.addEventListener("resize", updateWidth2);
     return () =>{
      window.removeEventListener("resize", updateWidth);
      window.removeEventListener("resize", updateWidth2);
     } 
  }, []);

  function chunkArray(arr, size = 3) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }
  const reload = useCallback(async () => {
    setLoading(true);
    let res = await GetCourseContent();
    if (res.code !== 0) {
      alert(res.message);
    } else {
      setLoading(false);
      let mainCourse = chunkArray(
        res.result.filter((i) => i.category === 1 && i.showStatus===1)
      );
      let trainCourse = chunkArray(
        res.result.filter((i) => i.category === 2 && i.showStatus === 1)
      );
      setCourseList((state) => ({
        ...state,
        mainCourse,
        trainCourse,
      }));
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return (
    <Row>
      {loading ? (
        <Skeleton />
      ) : (
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          <div className="our-course-pc">
            <div className="threecoursehome">
              <div className="homeMainCourseBox">
                <div className="mainCourseText">
                  <img
                    src={courseTitleIcon}
                    className="titleImgleft"
                    alt="加载中"
                  />
                  <div className="centerTitle">
                    <div>K大王牌正课</div>
                    <div>MAIN COURSES</div>
                  </div>
                  <img
                    alt="加载中"
                    className="titleImgRight"
                    src={courseTitleIcon}
                  />
                </div>
                <div className="slider-wrapper">
                  <div className="slider-window" ref={windowRef}>
                    <div
                      className="slider-track"
                      style={{
                        transform: `translateX(-${pageIndex * windowWidth}px)`,
                      }}
                    >
                      {courseList.mainCourse.map((page, index) => {
                        return (
                          <div key={index} className="slider-page">
                            {page.map((i, index) => {
                              return (
                                <div key={i.id} className="slider-item">
                                  <div className="itemCourseBox">
                                    <div className="courseNameBox">
                                      <div className="nameIcon">
                                        <img
                                          src={i.pcIcon}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          alt="加载中"
                                        />
                                      </div>
                                      {/* <div className="courseTitleBox">
                                        <div className="cnTitle">
                                          {i.nameCN}
                                        </div>
                                        <div className="enTItle">{i.name}</div>
                                      </div> */}
                                    </div>
                                    <div className="mainCourseContent">
                                      <pre
                                        style={{
                                          lineHeight: 1.5,
                                          whiteSpace: "pre-wrap",
                                          wordWrap: "break-word",
                                          overflow: "hidden",
                                          // height: "400px",
                                          fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
                                        }}
                                      >
                                        <div
                                          className="braft-output-content"
                                          dangerouslySetInnerHTML={{
                                            __html: i.courseContent,
                                          }}
                                        ></div>
                                      </pre>
                                    </div>

                                    <div className="course-look-icon">
                                      <NavLink
                                        to={`/course/${i.id}?targetCode=${i.targetCode*1}`}
                                      >
                                        <div className="btn-ajust">
                                          <span>查看课程</span>
                                        </div>
                                      </NavLink>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                    {pageIndex > 0 ? (
                      <div className="arowBox">
                        <img
                        alt="加载中"
                          src={arrow}
                          className={`arrowLeft`}
                          onClick={PrevPage}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {courseList.mainCourse.length > maxPage && (
                      <img
                      alt="加载中"
                        src={arrow}
                        className={`arrowright ${
                          pageIndex === maxPage ? "disabled" : ""
                        }`}
                        onClick={nextPage}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="trainCourseBox">
                <div className="mainCourseText">
                  <img
                    src={courseTitleIcon}
                    className="titleImgleft"
                    alt="加载中"
                  />
                  <div className="centerTitle">
                    <div>零基础训练营及其他</div>
                    <div>FOR STARTERS & OTHER COURSES</div>
                  </div>
                  <img
                    className="titleImgRight"
                    src={courseTitleIcon}
                    alt="加载中"
                  />
                </div>
                <div className="slider-wrapper">
                  <div className="slider-window" ref={windowRef2}>
                    <div
                      className="slider-track"
                      style={{
                        transform: `translateX(-${
                          pageIndex2 * windowWidth2
                        }px)`,
                      }}
                    >
                      {courseList.trainCourse.map((page, index) => {
                        return (
                          <div key={index} className="slider-page">
                            {page.map((i, index) => {
                              return (
                                <div key={i.id} className="slider-item">
                                  <div className="itemCourseBox">
                                    <div className="courseNameBox">
                                      <div className="nameIcon">
                                        <img
                                          src={i.pcIcon}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          alt="加载中"
                                        />
                                      </div>
                                    </div>
                                    <div className="mainCourseContent">
                                      <pre
                                        style={{
                                          lineHeight: 1.5,
                                          whiteSpace: "pre-wrap",
                                          wordWrap: "break-word",
                                          overflow: "hidden",
                                          // height: "400px",
                                          fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
                                        }}
                                      >
                                        <div
                                          className="braft-output-content"
                                          dangerouslySetInnerHTML={{
                                            __html: i.courseContent,
                                          }}
                                        ></div>
                                      </pre>
                                    </div>

                                    <div className="course-look-icon">
                                      <NavLink
                                        to={`/course/${i.id}?targetCode=${
                                          i.targetCode * 1
                                        }`}
                                      >
                                        <div className="btn-ajust">
                                          <span>查看课程</span>
                                        </div>
                                      </NavLink>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                    {pageIndex2 > 0 ? (
                      <div className="arowBox">
                        <img
                        alt="加载中"
                          src={arrow}
                          className={`arrowLeft`}
                          onClick={PrevPage2}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {courseList.trainCourse.length > maxPage && (
                      <img
                      alt="加载中"
                        src={arrow}
                        className={`arrowright ${
                          pageIndex2 === maxPage2 ? "disabled" : ""
                        }`}
                        onClick={nextPage2}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      )}
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <div className="ourCoursePhBox">
          <img
            src={mainCourseImg1}
            alt="加载中"
            width={"100%"}
            height={"100%"}
            className=""
          />
          <div className="mainCoursePh">
            <div className="mainCourseTitlePh">
              <img
                src={courseTitleIcon}
                className="titleImgleft"
                alt="加载中"
              />
              <div className="centerTitle">
                <div>K大王牌正课</div>
                <div>MAIN COURSES</div>
              </div>
              <img
                className="titleImgRight"
                src={courseTitleIcon}
                alt="加载中"
              />
            </div>
            <div className="mainCourseContentPh">
              {courseList.mainCourse.map((page, pageindex) => {
                return (
                  <div key={pageindex}>
                    {page.map((i, index) => {
                      return (
                        <div className="itemCourseBoxPh" key={i.id}>
                          <div className="itemCourseIconBox">
                            <img
                              src={i.icon}
                              alt="加载中"
                              className="courseIconPh"
                            />
                            <div className="checkButton">
                              <NavLink to={`/course/${i.id}`}>
                                <div>
                                  <span>查看课程</span>
                                </div>
                              </NavLink>
                            </div>
                          </div>
                          <div className="">
                            <pre
                              style={{
                                width: "4.5rem",
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                                overflow: "hidden",
                                marginBottom: 0,
                                // height: "400px",
                                fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
                              }}
                            >
                              <div
                                className="braft-output-content"
                                dangerouslySetInnerHTML={{
                                  __html: i.courseContent,
                                }}
                              ></div>
                            </pre>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
          <img
            src={trainCourseImg1}
            alt="加载中"
            width={"100%"}
            height={"100%"}
            style={{ marginTop: "0.5rem" }}
          />

          <div className="mainCourseTitlePh">
            <img src={courseTitleIcon} className="titleImgleft" alt="加载中" />
            <div className="centerTitle">
              <div>零基础训练营及其他</div>
              <div>FOR STARTERS & OTHER COURSES</div>
            </div>
            <img className="titleImgRight" src={courseTitleIcon} alt="加载中" />
          </div>
          <div className="mainCourseContentPh">
            {courseList.trainCourse.map((page, pageindex) => {
              return (
                <div key={pageindex}>
                  {page.map((i, index) => {
                    return (
                      <div className="itemCourseBoxPh" key={i.id}>
                        <div className="itemCourseIconBox">
                          <img
                            src={i.icon}
                            alt="加载中"
                            className="courseIconPh"
                          />
                          <div className="checkButton">
                            <NavLink to={`/course/${i.id}`}>
                              <div>
                                <span>查看课程</span>
                              </div>
                            </NavLink>
                          </div>
                        </div>
                        <div className="">
                          <pre
                            style={{
                              width: "4.5rem",
                              whiteSpace: "pre-wrap",
                              wordWrap: "break-word",
                              overflow: "hidden",
                              marginBottom: 0,
                              // height: "400px",
                              fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
                            }}
                          >
                            <div
                              className="braft-output-content"
                              dangerouslySetInnerHTML={{
                                __html: i.courseContent,
                              }}
                            ></div>
                          </pre>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </Col>
    </Row>
  );
}

function parseStr(str = "") {
  return str.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, "")) / 1.7);
    return `font-size:${newValue}`;
  });
}
export const RenderHtml = (props) => {
  let {
    state: { content: __html },
    dom,
  } = props;
  //__html
  return (
    <pre
      id="prevs"
      style={{
        lineHeight: "1",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        overflow: "hidden",
        fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
      }}
    >
      <div
        className="braft-output-content"
        style={{ width: "100%" }}
        ref={dom}
        dangerouslySetInnerHTML={{ __html: parseStr(__html) }}
      ></div>
    </pre>
  );
};
